import { Component, Input } from '@angular/core';
import { IChatItem } from '@interfaces/index';

@Component({
  selector: 'app-message-content',
  templateUrl: './message-content.component.html',
  styleUrls: ['./message-content.component.scss']
})
export class MessageContentComponent {
  @Input() chatData!: IChatItem;
  @Input() messageType: 'person' | 'ollie' | 'ollieHelp' = 'person';

  private lastContentHash = '';
  private cachedContent: string[] = [];

  constructor() { }

  get formattedContent(): string[] {
    const contentHash = this.chatData?.content_array?.join('|') || this.chatData?.content || '';

    if (this.lastContentHash !== contentHash) {
      this.lastContentHash = contentHash;
      this.cachedContent = Array.isArray(this.chatData.content_array) && this.chatData.content_array.length
        ? [...this.chatData.content_array]
        : typeof this.chatData.content === 'string' && this.chatData.content.trim() !== ''
          ? this.chatData.content.split('\n')
          : [];
    }

    return this.cachedContent;
  }
}
